<template>
  <div :class="[baseCss, 'fixed', 'bottom-0', top ? 'top-0' : null, 'p-4', 'fixed', right ? 'right-0' : 'left-0', 'select-none', 'overflow-y-auto', 'pointer-events-none', 'outline-none']" :style="{zIndex}">
    <alert
      @click.native.stop="handleClick(notification)"
      @dismiss="$emit('dismiss', true)"
      ref="alert"
      v-model="notification.visible"
      v-for="(notification, index) in notifications"
      :key="index"
      :icon="notification.icon"
      :icon-provider="iconProvider"
      :data-uuid="notification.uuid"
      :runded="notification.rounded || true"
      :style="{width}"
      :class="[ifClickIsFunction(notification) ? 'cursor-pointer' : null, 'pointer-events-auto','my-2']"
      :dismissible="!notification.persistent"
      :elevation="elevation" :type="notification.type || 'info'">
      <div v-html="notification.title" :class="['text-sm', 'pb-1', 'truncate', 'font-bold']" />
      <div v-html="notification.text" :class="['text-xs']" />
    </alert>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Notification',
  mixins: [
    methods
  ],
  data () {
    return {
      notifications: [],
      baseCss: this.componentBaseCss('notification', [])
    }
  },
  props: {
    zIndex: {
      type: Number,
      default: 2000
    },
    right: {
      type: Boolean,
      default: true
    },
    top: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '320px'
    },
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    elevation: {
      type: String,
      default: 'xl'
    }
  },
  watch: {
    item () {
      const item = this.item
      item.uuid = this.$uuidv4()
      this.notifications[this.top ? 'unshift' : 'push'](item)
      if (item.autoClose) {
        setTimeout(() => {
          this.removeItem(item.uuid)
        }, item.autoClose)
      }
    }
  },
  methods: {
    ifClickIsFunction (notification) {
      return notification.click && typeof notification.click === 'function'
    },
    handleClick (notification) {
      if (this.ifClickIsFunction(notification)) {
        this.removeItem(notification.uuid)
        notification.click()
      }
    },
    removeItem (uuid) {
      this.notifications.splice(this.notifications.findIndex(item => item.uuid === uuid), 1)
    }
  }
}
</script>
<style>
@media (max-width: 480px) {
  .bcq-notification .bcq-alert
  {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/notification/notification.vue